<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0>
        
        <scroll-area>
          
          <template slot="body">

            <v-layout shrink>
              <v-layout fill-height justify-start>
                <v-flex xs7 pa-0>
                  <v-layout fill-height justify-start>
                    <v-flex xs3 pa-0>
                      <v-tooltip dark color="secondary" right>
                        <v-btn :data-testid="$options.name + 'v-btn' + 'downloadCopy'" block small slot="activator" color="accent"
                        @click="() => downloadCopy()" 
                        >
                          <v-layout fill-height justify-start align-center py-1>
                            <v-flex shrink pr-1 pt-1>
                              <svg-icon
                                color="white"
                                :name="'certificate_export'"
                                width="20"
                              />
                            </v-flex>
                              <span>{{$t('export sertificate (CA)')}}</span>
                          </v-layout>
                        </v-btn>
                        <span>{{ $t('export sertificate CA') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout shrink justify-start mb-3 >
              <v-layout column  justify-start >

                <v-layout column shrink pt-2>

                  <v-layout style="height: 40px" px-0 pb-3>
                    <v-layout fill-height class="title">
                      <v-layout align-center justify-start px-0>
                        <span class="body-2">{{ $t('Основная информация') }}</span>
                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout v-if="getObj.baseInfo?.version" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ВЕРСИЯ (Version)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'baseInfo.version'"
                        v-model="model.obj.baseInfo.version"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.baseInfo?.serialNumber" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('СЕРИЙНЫЙ НОМЕР (Serial Number)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'baseInfo.serialNumber'"
                        v-model="model.obj.baseInfo.serialNumber"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.baseInfo?.signatureAlgorithm" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('АЛГОРИТМ ПОДПИСИ (Signature Algorithm)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'baseInfo.signatureAlgorithm'"
                        v-model="model.obj.baseInfo.signatureAlgorithm"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-layout>

                <v-layout column shrink pt-0>

                  <v-layout style="height: 40px" px-0 py-3>
                    <v-layout fill-height class="title">
                      <v-layout align-center justify-start px-0>
                        <span class="body-2">{{ $t('Срок действия') }}</span>
                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout v-if="getObj.validity?.status" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('СТАТУС (Validity)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'validity.status'"
                        v-model="model.obj.validity.status"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.validity?.notBefore" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ДЕЙСТВИТЕЛЕН С (Not Before)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'validity.notBefore'"
                        v-model="model.obj.validity.notBefore"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.validity?.notAfter" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ДЕЙСТВИТЕЛЕН ДО (Not After)')"               
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'validity.notAfter'"
                        v-model="model.obj.validity.notAfter"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-layout>
              </v-layout>
              
              <v-layout column justify-start >
                <v-layout column shrink pt-2 class='white'>

                  <v-layout style="height: 40px" px-0 pb-3>
                    <v-layout fill-height class="title">
                      <v-layout align-center justify-start px-0>
                        <span class="body-2">{{ $t('Издатель / Субъект') }}</span>
                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout v-if="getObj.subject?.CN" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ИМЯ СЕРТИФИКАТА (CN)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'subject.CN'"
                        v-model="model.obj.subject.CN"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.subject?.O" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ОРГАНИЗАЦИЯ (О)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'subject.O'"
                        v-model="model.obj.subject.O"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.subject?.OU" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ПОДРАЗДЕЛЕНИЕ (OU)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'subject.OU'"
                        v-model="model.obj.subject.OU"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.subject?.C" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('СТРАНА (С)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'subject.C'"
                        v-model="model.obj.subject.C"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.subject?.ST" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('РЕГИОН / ОБЛАСТЬ (ST)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'subject.ST'"
                        v-model="model.obj.subject.ST"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.subject?.L" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ГОРОД (l)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'subject.L'"
                        v-model="model.obj.subject.L"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-layout>

              </v-layout>
            </v-layout>

            <v-divider></v-divider>

            <v-layout shrink justify-start mb-3 >

              <v-layout column  justify-start >

                <v-layout column shrink pt-2>

                  <v-layout style="height: 40px" px-0 py-3>
                    <v-layout fill-height class="title">
                      <v-layout align-center justify-start px-0>
                        <span class="body-2">{{ $t('Ключ и отпечаток') }}</span>
                      </v-layout>
                    </v-layout>
                  </v-layout>

                  <v-layout v-if="getObj.fingerprint?.sha_256" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ОТПЕЧАТОК (SHA-256)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'fingerprint.sha_256'"
                        v-model="model.obj.fingerprint.sha_256"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.fingerprint?.publicKeyFingerprint" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ПУБЛИЧНЫЙ ОТПЕЧАТОК (PublicKeyFingerprint)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'fingerprint.publicKeyFingerprint'"
                        v-model="model.obj.fingerprint.publicKeyFingerprint"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.fingerprint?.algorithm" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('АЛГОРИТМ (Algorithm)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'fingerprint.algorithm'"
                        v-model="model.obj.fingerprint.algorithm"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout v-if="getObj.fingerprint?.keySize" fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('ДЛИНА КЛЮЧА (Key Size)')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'fingerprint.keySize'"
                        v-model="model.obj.fingerprint.keySize"
                        light
                        outline
                        flat
                        readonly
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                </v-layout>

              </v-layout>
              
              <v-flex xs6>

              </v-flex>
            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface BaseInfo {
  version: string | null
  serialNumber: string | null
  signatureAlgorithm: string | null
}

interface Validity {
  status: string | null
  notBefore: string | null
  notAfter: string | null
}

interface Subject {
  CN: string | null
  O: string | null
  C: string | null
  ST: string | null
  L: string | null
  OU: string | null
}

interface Fingerprint {
  publicKeyFingerprint: string | null
  algorithm: string | null
  keySize: string | null
}

interface CertInfo {
  baseInfo: BaseInfo
  validity: Validity
  subject: Subject
  fingerprint: Fingerprint
}

interface ModelData {
  obj: CertInfo
}

interface FileItem {
  id?: string
  name?: string
  [key: string]: any
}

interface ItemsResponse {
  items?: FileItem[]
  [key: string]: any
}

export default Vue.extend({
  name: 'SERTIFICATES-CA',

  components: {
    scrollArea,
    svgIcon,
  },

  props: {},

  data(): {
    clear: boolean
    selectedCrt: FileItem | null
    crt: FileItem[]
    meta: any | null
    data: any | null
    model: ModelData
    current: {
      files: any[]
      update: string[]
    }
  } {
    return {
      clear: false,
      selectedCrt: null,
      crt: [],
      meta: null,
      data: null,
      model: {
        obj: {
          baseInfo: {
            version: null,
            serialNumber: null,
            signatureAlgorithm: null,
          },
          validity: {
            status: null,
            notBefore: null,
            notAfter: null,
          },
          subject: {
            CN: null,
            O: null,
            C: null,
            ST: null,
            L: null,
            OU: null,
          },
          fingerprint: {
            publicKeyFingerprint: null,
            algorithm: null,
            keySize: null,
          },
        },
      },
      current: {
        files: [],
        update: []
      },
    }
  },

  computed: {
    getObj(): CertInfo {
      return this.model.obj
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      await this.loadCrt()
    },

    async loadCrt(): Promise<void> {
      console.log(this.$options.name, 'loadCrt', 'START')
      try {
        const items_ = await this.$bridge.customQuery('scripter', 'filemanager/files/Lw/children', { data: { orderBy: 'name', orderDirection: 'ASC' } }, 'GET') as FileItem[] | ItemsResponse

        const info = await this.$bridge.customQuery('core', 'certs/infoCert', {}, 'get') as CertInfo
        if (info) {
          console.log(this.$options.name, 'loadCrt info', info)
          this.$set(this.model, 'obj', info)
        }

        let items: FileItem[] = []
        if (Array.isArray(items_)) {
          items = items_
        } else if (items_?.items && Array.isArray(items_.items)) {
          items = items_.items
        }
        console.log(this.$options.name, 'loadCrt items', items)

        const pgBackUpFiles = items.find(el => el.name === 'certificates')
        if (pgBackUpFiles) {
          console.log(this.$options.name, 'loadCrt pgBackUpFiles', pgBackUpFiles)
          const data = await this.$bridge.customQuery('scripter', `filemanager/files/${pgBackUpFiles.id}/children`, { data: { orderBy: 'name', orderDirection: 'ASC' } }, 'GET') as ItemsResponse
          if (data?.items && Array.isArray(data.items)) {
            console.log(this.$options.name, 'loadCrt data.items', data.items)
            const crtCa = data.items.find(item => item.name === 'ca.crt')
            if (crtCa) {
              console.log(this.$options.name, 'loadCrt crtCa', crtCa)
              this.selectedCrt = crtCa
            }
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'loadCrt smth wrong', error)
      }
    },

    async downloadCopy(): Promise<void> {
      try {
        if (!this.selectedCrt) return
        this.setLoader('downloadCopy', true)

        const r = await this.$bridge.customQuery('scripter', 'filemanager/download', { items: this.selectedCrt.id }, 'get')
        this.$store.dispatch('file/download/save', {
          content: r,
          filename: this.selectedCrt.name
        })

        this.setLoader('downloadCopy', false)
      } catch (error) {
        console.error(this.$options.name, 'downloadCopy smth wrong', error)
        this.setLoader('downloadCopy', false)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.model = {
        obj: {
          baseInfo: {
            version: null,
            serialNumber: null,
            signatureAlgorithm: null,
          },
          validity: {
            status: null,
            notBefore: null,
            notAfter: null,
          },
          subject: {
            CN: null,
            O: null,
            C: null,
            ST: null,
            L: null,
            OU: null,
          },
          fingerprint: {
            publicKeyFingerprint: null,
            algorithm: null,
            keySize: null,
          },
        },
      }
    },
  },
})
</script>

<style lang="css" scoped>
.toolbar_castom {
    border: solid 1px #9F9F9F ;
    border-radius: 2px;
    /* background-color: #D4EEFC */
  }
</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
